import { render } from "./myPoint.vue?vue&type=template&id=29ac2452"
import script from "./myPoint.vue?vue&type=script&lang=js"
export * from "./myPoint.vue?vue&type=script&lang=js"

import "./myPoint.vue?vue&type=style&index=0&id=29ac2452&lang=scss"

import exportComponent from "/Users/opm/opm-vue-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__